import { colors } from '../constants';
import { STATUS_COLOR_MAP } from '../constants/projectsPage';

/** Value aligned with raise-query submit: description, else name */
export const projectStoredValue = (p) =>
  (p?.description || p?.name || p?.projectName || '').trim();

/**
 * Non-admin UI: "name - description" with fallbacks
 * @param {Object} project
 * @returns {string}
 */
export const formatProjectNameDescription = (project) => {
  if (!project) return '';
  const name = (project.name || '').trim();
  const desc = (project.description || '').trim();
  if (name && desc) return `${name} - ${desc}`;
  return name || desc || '';
};

/**
 * Map stored query.projectName to display label using /projects catalog
 * @param {string} storedProjectName
 * @param {Array} projectsCatalog
 * @returns {string}
 */
export const formatQueryProjectNameForDisplay = (storedProjectName, projectsCatalog = []) => {
  const raw = (storedProjectName || '').trim();
  if (!raw) return '';
  const list = Array.isArray(projectsCatalog) ? projectsCatalog : [];
  if (list.length === 0) return raw;
  const match = list.find((proj) => {
    const n = (proj.name || '').trim();
    const d = (proj.description || '').trim();
    const primary = projectStoredValue(proj);
    if (primary === raw) return true;
    if (n === raw) return true;
    if (d === raw) return true;
    if (formatProjectNameDescription(proj) === raw) return true;
    return false;
  });
  return match ? formatProjectNameDescription(match) : raw;
};

/**
 * Build project filter dropdown options from API list (value = stored id string for filtering queries)
 * @param {Array} projectsData
 * @returns {Array<{value: string, label: string}>}
 */
export const buildProjectFilterOptionsFromApi = (projectsData) => {
  const list = Array.isArray(projectsData) ? projectsData : [];
  const byValueKey = new Map();
  list.forEach((project) => {
    const stored = projectStoredValue(project);
    if (!stored) return;
    const key = stored.toLowerCase();
    if (!byValueKey.has(key)) {
      byValueKey.set(key, {
        value: stored,
        label: formatProjectNameDescription(project),
      });
    }
  });
  return Array.from(byValueKey.values()).sort((a, b) =>
    (a.label || '').localeCompare(b.label || '', undefined, { sensitivity: 'base' })
  );
};

/**
 * Get status color for a project status
 * @param {string} status - Project status
 * @returns {string} Color hex code
 */
export const getStatusColor = (status) => {
  const colorKey = STATUS_COLOR_MAP[status];
  if (!colorKey) return colors.textSecondary;
  
  switch (colorKey) {
    case 'success':
      return colors.success;
    case 'warning':
      return colors.warning;
    case 'info':
      return colors.info;
    case 'error':
      return colors.error;
    default:
      return colors.textSecondary;
  }
};
